// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"modalContainer-RN7QY","modalHeader":"modalHeader-3qWW6","modalBody":"modalBody-2hsCG","modalButtons":"modalButtons-1cLV1","confirmButton":"confirmButton-2E5DN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/privacy_center/manage/_countrySelect.css
// module id = 1254
// module chunks = 1